import { useEffect, useState } from "react";
import "./profile.scss";
import { post } from "../../common/services/api-service";
import { useAppDispatch, useAppSelector } from "../../hooks/typed-hooks";
import { ICompanyInsightInfo, companyInsightSelector, updateCompanyInsight } from "../../redux/reducers/company-insight/companyInsightSlice";

interface Insight {
  Question: string;
  Answer: string;
  QuestionType: string[];
}

interface InsightInput {
  Types: string[];
  Question: string;
}

const ProfilePage: React.FC = () => {


  const webScrapingAPIURL = "http://localhost:7001/scrape";
  const insightGenAPIURL = "http://localhost:6001/ask";
  const geminiInsightAPIURL = "http://localhost:6001/generateInsight";
  

  const [websiteUrl, setWebsiteUrl] = useState<string>("");
  const [businessInsights, setBusinessInsights] = useState<Insight[]>([]);
  const [companyInsightInfo, setCompanyInsightInfo] = useState<ICompanyInsightInfo>({});
  const [isMLProcessing, setIsMLProcessing] = useState<boolean>(false);
  const [mlProcessingStatusMessage, setMlProcessingStatusMessage] = useState<string>("");
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setWebsiteUrl(event.target.value);
  };


  const selectCompanyInsight = useAppSelector(companyInsightSelector);
  const dispatch = useAppDispatch();

  
  useEffect(()=>{
    console.log("Company insight data changed", selectCompanyInsight);

    setCompanyInsightInfo(selectCompanyInsight)

  }, [selectCompanyInsight]);

//   let businessInsights: Insight[] = [{Question: "First question", Answer: "First question answer",QuestionType : ["Question type"]}];

  const GenerateGeminiInsight = async() =>{
     let webSiteTextContent: string = await ScrapWebsiteData(websiteUrl);
     let question = "Identify the company name, country, location, contact number, email address, branch information, social media presence details, services they offers, product details, their vision and other important insights from the content";
     let answers = await AskQuestionWithContextToGemini(webSiteTextContent, question);
     console.log(answers)
     //let answers = '{"branch_information":"3 outlets, 2 easy pickup counters & Online ordering.","company_name":"Ambrosia","contact_number":"0471 2332211","country":"India","email_address":"info@theambrosia.com","location":"TVM","other_insights":["Wide Variety","Explore our wide range of fresh creak cakes, Cartoon cakes, customized Cakes.","TVM, We are Everywhere","Fast Delivery","Fast checkout & delivery with multiple payment options such as Cash on delivery, UPI, Wallets, Netbanking, Debit/Credit card options.","Get H\\nFast\\nDelivery"],"products":["Cakes","Halwas","Burgers","Pizzas","Vancho","Snicker Cake","Real Milk Chocolate","White Chocolate Cake (400gm)","Butter Cream Cake","Vanilla Blueberry","Blueberry Chocolate","Plum Cake","White Forest","Fresh creak cakes","Cartoon cakes","Customized Cakes","Cookies","Fried Chicken","Value Meals","Black Halwa","Milk Halwa","Big Whopper","Bacon Cheese Burger","Chicken Burger","All Veggies Burger","Bakehouse Special","Barbecue Chicken","Triple Cheese","Indian Hot"],"services":["Online ordering","Fast delivery","Multiple payment options (Cash on delivery, UPI, Wallets, Netbanking, Debit/Credit card options)"],"social_media_presence":{"facebook":"https://www.facebook.com/theambrosiabakehouse","instagram":"https://www.instagram.com/theambrosiabakehouse/?hl=en","linkedin":"https://in.linkedin.com/company/the-ambrosia"},"vision":"25 Years of Baking Culture\\nAmbrosia has been delighting customers and foodies alike with a heritage of baking for over 24 years.","website":"https://theambrosia.com/"}';
      for(let key in answers){

        let insight = answers[key];
        let textInsight = "";
        if(Array.isArray(insight)){
            for(let item in insight){
                let insightValue = insight[item];
                if(typeof(insightValue) == "object"){
                    for(let obj in insightValue){
                        textInsight += `${obj}(${insightValue[obj]}) `;
                    }
                }else{
                    textInsight += `${insightValue},`;
                }
            }            
            textInsight = insight.join(',')
        }else if(typeof(insight) == "object"){
            for(let obj in insight){
                textInsight += `${obj}(${insight[obj]}) `;
            }
        }else{
            textInsight = insight;
        }

        if(textInsight.trim() != ""){
            setBusinessInsights((prevInsights)=>[...prevInsights, {
                Question: "Generate insight",
                Answer: textInsight,
                QuestionType: [key.replace(/_/ig, " ").toUpperCase()]
            }]);

            // Dispatch data to react store
            dispatch(
              updateCompanyInsight({
                ...companyInsightInfo,
                answers: answers,
              })
            );

        }
      }


    //  answers.array.forEach((answer:any) => {
    //     setBusinessInsights((prevInsights)=>[...prevInsights, {
    //         Question: question,
    //         Answer: answer,
    //         QuestionType: insightInput.Types,
    //       }]);
    //  });
  };

  const GenerateInsight = async () => {
    //alert("Generate insight " + websiteUrl);

    // Scrap web site content
    let webSiteTextContent: string = await ScrapWebsiteData(websiteUrl);

    let questions: InsightInput[] = [
      { Question: "which are the products specified ?", Types: ["Product"] }, //"What are the products are specified in the context?",
      { Question: "What service they offers?", Types: ["Services"] },
      { Question: "what is the contact number ?", Types: ["Contact Number"] },
      {
        Question: "what is the email id?",
        Types: ["Email", "Contact Details"],
      },
      { Question: "Where they are located?", Types: ["Location"] },
      { Question: "Does they provide online service ?", Types: ["Service"] },
      { Question: "What are their social media links ?", Types: ["Social Media"]}
    ];
    // Send request to service to generate insight
    questions.forEach(async (insightInput) => {
        
      let question = insightInput.Question; // "What are the major services they provides?";
      let answer = await AskQuestionWithContext(webSiteTextContent, question);
      console.log(answer)
      setBusinessInsights((prevInsights)=>[...prevInsights, {
        Question: question,
        Answer: answer,
        QuestionType: insightInput.Types,
      }]);
    //   businessInsights.push({
    //     Question: question,
    //     Answer: answer,
    //     QuestionType: insightInput.Types,
    //   });
    });
  };

  const ScrapWebsiteData = async (webURL: string) => {
    setIsMLProcessing(true);
    setMlProcessingStatusMessage("Web Scraping started");
    let response = await post(webScrapingAPIURL, { url: webURL });
    console.log("Web scrap response ");
    console.log(response);
    let links = response.links;
    // todo: code for avoid all links that match webURL
    links = links.filter((link:string[])=>link[1].indexOf(webURL) === -1);
    let linkText = links.map((l:any)=>l.join(':')).join(',')
    console.log(linkText);
    setMlProcessingStatusMessage("Received website contents");
    setIsMLProcessing(false);
    return `${response.content} ${linkText}}` ;
  };

  const AskQuestionWithContext = async (context: string, question: string) => {
    let response = await post(insightGenAPIURL, {
      context: context,
      question: question,
    });
    console.log("Web scrap response " + response);
    return response.answer;
  };

  const AskQuestionWithContextToGemini = async (context: string, question: string) => {
    setIsMLProcessing(true);
    setMlProcessingStatusMessage("Insight generation process initiated");
    let response = await post(geminiInsightAPIURL, {
      context: context,
      question: question,
    });
    console.log("Web scrap response " + response);
    setIsMLProcessing(false);
    setMlProcessingStatusMessage("Insight generation completed");
    return response.answers;
  };

  return (
    <>
      <span className="profile-header">Tell us about your company</span>
      <div className="profile-builder">
        <section className="chat-view">
          <div className="insight-input-box">
            <span>Website URL</span>
            <input type="text" onChange={onChange} />
            <input type="button" onClick={GenerateInsight} value="Generate" />
            <input type="button" onClick={GenerateGeminiInsight} value="Generate with Gemini" />
            { isMLProcessing ? 
            <div className="insight-message">
            <div className="procssing-indicator" ></div>
            <label className="processing-status-message">{mlProcessingStatusMessage}</label>
            </div>
            : null
            }
          </div>
        </section>
        <section className="insight-view">
          {businessInsights.map((insight: Insight) => (
            <div className="business-insight-box" >
              <div className="bib-header">{insight.QuestionType.join("|")}</div>
              <div className="bib-body">{insight.Answer}</div>
            </div>
          ))}
        </section>
      </div>
    </>
  );
};

export default ProfilePage;
